var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.error
    ? _c("div", [
        _c(
          "h4",
          {
            staticClass: "sm:text-md text-red leading-tight",
            attrs: { role: "alert" },
          },
          [
            _vm._v(
              "\n    Unable to calculate quantity, please ensure all input is valid.\n  "
            ),
          ]
        ),
      ])
    : _c("div", [
        _c(
          "h4",
          { staticClass: "sm:text-md flex items-center leading-tight" },
          [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]
        ),
        _vm._v(" "),
        _c("p", { staticClass: "sm:text-md font-semibold leading-tight" }, [
          _vm._v(
            "\n    " + _vm._s(_vm._f("formatVolume")(_vm.quantity)) + "\n  "
          ),
        ]),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }